export const getWorkingHours = ({ liveLook }) => liveLook.common.workingHours;
export const getActiveFilters = ({ liveLook }) => liveLook.filters.initFilters;
